import { EmployeeBookingReportsComponent } from './employee-booking-reports/employee-booking-reports.component';
import { HaltReportsComponent } from './halt-reports/halt-reports.component';
import { MomentReportsComponent } from './moment-reports/moment-reports.component';
import { OfflineReportComponent } from './offline/offline-component';
import { OverspeedReportsComponent } from './over-speed-reports/over-speed-reports.component';
import { ProductivityComponent } from './productivity-reports/productivity-reports.component';
import { ReportsComponent } from './reports.component';
import { SosReportComponent } from './sos-report/sos-report.component';
import { VehicleBookingHistoryReportsComponent } from './vehicle-booking-history-reports/vehicle-booking-history-reports.component';
import { RouteBookingReportsComponent } from './route-booking-report/route-booking-reports.component';

import { SafeDropComponent } from './safe-drop/safe-drop-component';
import { TripReportsComponent } from './trip-reports/trip-reports-component';
import { ComplaintRatingsComponent } from './complaint-ratings/complaint-ratings.component';
import { AppInstallationReportComponent } from './app-installation-report/app-installation-report.component';
import { DriverAppInstallationReportComponent } from './app-installation-report/driver-app-installation-report/driver-app-installation-report.component';
import { EmpAppInstallationReportComponent } from './app-installation-report/emp-app-installation-report/emp-app-installation-report.component';
import { ExcessEmployeeReportComponent } from './excess-employee-report/excess-employee-report.component';
import { SecuritycheckComponent } from './attendance-reports/securitycheck/securitycheck.component';
import { AttendanceReportsComponent } from './attendance-reports/attendance-reports.component';
import { EmployeeBookingCountComponent } from './employee-booking-count/employee-booking-count.component';
import { TripCountsComponent } from './trip-reports/trip-counts/trip-counts.component';
import { HeadReportsComponent } from './head-reports/head-reports.component';
import { VehicleWiseReportComponent } from './vehicle-wise-report/vehicle-wise-report.component';
import { NoShowReportComponent } from './no-show-report/no-show-report.component';
import { GeoReportsComponent } from './geo-reports/geo-reports.component';
import { RosterTripCountsComponent } from './roster-trip-counts/roster-trip-counts.component';
import { VehicleAuditReportComponent } from './vehicle-audit-report/vehicle-audit-report.component';
import { NewRosterTripCountsComponent } from './new-roster-trip-counts/new-roster-trip-counts.component';
import { TowAlertReportComponent } from "./towalert-report/towalert-report.component";
import { NightRideReportsComponent } from './night-ride-reports/night-ride-reports.component';
import { ContinuousDrivingComponent } from './continuous-driving-reports/continuous-driving-reports.component';
import { Component } from '@angular/core';
import { DriverAppUsageReportsComponent } from './driver-app-usage-reports/driver-app-usage-reports.component';
import {HarshAccelerationReportComponent} from './harsh-acceleration-report/harsh-acceleration-report.component';

export const ReportsRouting = [
    { path: '', redirectTo: 'report-dashboard', pathMatch: 'full' },
    { path: 'report-dashboard', component: ReportsComponent },
    { path: 'sos-reports', component: SosReportComponent },
    { path: 'movement-reports', component: MomentReportsComponent },
    { path: 'halt-reports', component: HaltReportsComponent },
    { path: 'overspeed-reports', component: OverspeedReportsComponent },
    { path: 'productivity-reports', component: ProductivityComponent },
    { path: 'offline-reports', component: OfflineReportComponent },
    { path: 'employee-booking-reports', component: EmployeeBookingReportsComponent },
    { path: 'excess-employee-report', component: ExcessEmployeeReportComponent },
    { path: 'vehicle-booking-history', component: VehicleBookingHistoryReportsComponent },
    { path: 'route-booking-history', component: RouteBookingReportsComponent },
    { path: 'safe-drop-reports', component: SafeDropComponent },
    { path: 'trip-reports', component: RosterTripCountsComponent },
    { path: 'mis-reports', component: NewRosterTripCountsComponent },
    { path: 'trip-count', component: TripCountsComponent },
    { path: 'attendance-reports', component: AttendanceReportsComponent },
    { path: 'security-reports', component: SecuritycheckComponent },
    { path: 'complaint-ratings', component: ComplaintRatingsComponent },
    {
        path: 'app-reports',
        children: [
            { path: '', component: AppInstallationReportComponent },
            // { path: '', redirectTo: 'employee', pathMatch:'full'},
            { path: 'employee', component: EmpAppInstallationReportComponent },
            { path: 'driver', component: DriverAppInstallationReportComponent },
        ]
    },
    { path: 'employee-booking-count', component: EmployeeBookingCountComponent },
    { path: 'head-reports', component: HeadReportsComponent },
    { path: 'vehicle-wise', component: VehicleWiseReportComponent },
    { path: 'no-show-report', component: NoShowReportComponent },
    { path: 'geo-reports', component: GeoReportsComponent },
    { path: 'roster-trip-count', component: TripReportsComponent },

    { path: 'vehicle-audit-report', component: VehicleAuditReportComponent },
    { path: 'towalert-report', component: TowAlertReportComponent },//towalert-report
    { path: 'continuous-driving-report', component: ContinuousDrivingComponent },
    { path: 'night-drive-report', component: NightRideReportsComponent },
    { path: 'harsh-acceleration-braking', component: HarshAccelerationReportComponent },
    // { path: 'driver-app-usage-reports', component: DriverAppUsageReportsComponent } 
    { path: 'mobile-app-usage-reports', component: DriverAppUsageReportsComponent } 
];


// export const ReportsRoutingBreadcrumb = [

//             //   { name: 'Dashboard', path: '/report-dashboard' },
//               { name: 'Movement', path: '/movement-reports' },
//               { name: 'Halt', path: '/halt-reports' },
//               { name: 'Overspeed', path: '/overspeed-reports' },
//               { name: 'Productivity', path: '/productivity-reports' },
//               { name: 'Offline', path: '/offline-reports' },
//               { name: 'SOS', path: '/sos-reports' },
//               { name: 'Employee Booking', path: '/employee-booking-reports' },
//               { name: 'Vehicle Booking History', path: '/vehicle-booking-history' },
//               { name: 'route Booking History', path: '/route-booking-history' },


// ];
